import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
// import "animate.css";

const PrivacyPolicy = () => {
  return (
    <div
      className="privacy-policy-section py-5"
      style={{
        background: "linear-gradient(135deg, #f8f9fa, #e9ecef)",
        minHeight: "100vh",
      }}
    >
      <Container>
        <Row className="justify-content-center text-center mb-4 animate__animated animate__fadeInDown">
          <Col lg={8}>
            <h1 className="fw-bold" style={{ color: "#007bff" }}>
              Privacy Policy
            </h1>
            <p className="text-muted">
              Your privacy is important to us. This Privacy Policy explains how
              we collect, use, and protect your information.
            </p>
          </Col>
        </Row>

        <Row className="g-4">
          <Col md={6} className="animate__animated animate__fadeInLeft">
            <Card className="shadow-lg border-0 rounded-4 h-100">
              <Card.Body>
                <Card.Title className="text-primary fw-semibold mb-3">
                  Information We Collect
                </Card.Title>
                <Card.Text>
                  We collect personal and non-personal information such as your
                  name, email, phone number, and browsing behavior to improve
                  our services.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} className="animate__animated animate__fadeInRight">
            <Card className="shadow-lg border-0 rounded-4 h-100">
              <Card.Body>
                <Card.Title className="text-primary fw-semibold mb-3">
                  How We Use Your Information
                </Card.Title>
                <Card.Text>
                  We use the collected information to process bookings, send
                  updates, and personalize your experience on our platform.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} className="animate__animated animate__fadeInUp">
            <Card className="shadow-lg border-0 rounded-4 h-100">
              <Card.Body>
                <Card.Title className="text-primary fw-semibold mb-3">
                  Data Security
                </Card.Title>
                <Card.Text>
                  We implement strict security measures to protect your data
                  against unauthorized access, alteration, or disclosure.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6} className="animate__animated animate__fadeInUp">
            <Card className="shadow-lg border-0 rounded-4 h-100">
              <Card.Body>
                <Card.Title className="text-primary fw-semibold mb-3">
                  Cookies & Tracking
                </Card.Title>
                <Card.Text>
                  We use cookies and tracking technologies to enhance your user
                  experience and analyze site traffic.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="mt-5 animate__animated animate__fadeInUpBig">
          <Col lg={10} className="mx-auto text-center">
            <h5 className="fw-semibold text-primary mb-3">Contact Us</h5>
            <p className="text-muted">
              If you have any questions or concerns about this Privacy Policy,
              please contact us at:
            </p>
            <p className="fw-bold mb-0">support@jayrajgroup.com</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PrivacyPolicy;